import { nameplatesShop, nameplatesShopNoCatalog } from "../../../Utils"
import { NamePlateBG } from "../../NamePlateBg/NamePlateBg"
import { BaseSeeds } from "./SeedListingLib"

export class NamePlateSeeds extends BaseSeeds {
    constructor(profileData, userData) {
        super("RewardRandomPool_NamePlateBg", profileData, userData)
    }

    evaluate(rng, total) {
        if (total.length === 0) {
            total = [...nameplatesShop()]
        }
        const res = rng.get_u32() % total.length
        const c = total[res]
        total.splice(res, 1)
        return c
    }

    add_to_list(potential_seeds, current_state, entries) {
        const nameplate_list = entries.map(entry => entry.Value.raw)
        potential_seeds.push([current_state.get_clone(), nameplate_list])
    }

    get_start_nameplate() {
        const res = [...nameplatesShopNoCatalog()].filter(k => !(this.profileData.NamePlateBgMap[k.Id] ?? false))
        return res
    }

    get_start_nameplate_catalog() {
        const res = [...nameplatesShop()].filter(k => !(this.profileData.NamePlateBgMap[k.Id] ?? false))
        return res
    }

    get_have_nameplate() {
        const res = [...nameplatesShop()].filter(k => this.profileData.NamePlateBgMap[k.Id] ?? false)
        return res
    }

    get_have_nameplateCatalog() {
        const res = [...nameplatesShopNoCatalog()].filter(k => this.profileData.NamePlateBgMap[k.Id] ?? false)
        return res
    }

    estimate_start() {
        return this.get_have_nameplateCatalog().length
    }

    estimate_end() {
        return this.get_have_nameplate().length - this.estimate_start()
    }

    estimate_pulls() {
        return this.get_start_nameplate_catalog().length
    }

    seed_fits(current_state, entries) {
        const nameplates = this.get_start_nameplate_catalog()
        for (let entry of entries) {
            const tmp = this.evaluate(current_state, nameplates)
            if (tmp.__RowId !== entry.Value.raw.__RowId) {
                return false
            }
        }
        return true
    }

    singlePull() {
        const tmp = this.evaluate(this.rng, this.nameplates)
        this.added_nameplate.push(tmp)
        return tmp
    }

    setUpPull() {
        this.nameplates = this.get_start_nameplate_catalog()
        this.added_nameplate = []
    }

    calculateResultHandler(currentSeed) {
        const res = []
        this.setUpPull()
        this.init_rng(currentSeed)
        for (let results = 0; results < this.estimate_pulls(); results++) {
            const tmp = this.singlePull()
            res.push({
                Idx: results + 1,
                Banner: (
                    <center>
                        <NamePlateBG elem={tmp} formless={true} fullSize={true} />
                    </center>
                ),
                Raw: [...this.added_nameplate],
                Seed: this.format_state(this.rng.get_state()),
                RawSeed: this.rng.get_state(),
                Update: true,
            })
        }
        return res
    }
}
